/* eslint-disable */
import _m0 from "protobufjs/minimal";
const protobufPackageSarasa = "decentraland.sdk.components";
function createBasePBVideoPlayer() {
    return {
        src: "",
        playing: undefined,
        position: undefined,
        volume: undefined,
        playbackRate: undefined,
        loop: undefined,
    };
}
/**
 * @public
 */
export var PBVideoPlayer;
(function (PBVideoPlayer) {
    function encode(message, writer = _m0.Writer.create()) {
        if (message.src !== "") {
            writer.uint32(10).string(message.src);
        }
        if (message.playing !== undefined) {
            writer.uint32(16).bool(message.playing);
        }
        if (message.position !== undefined) {
            writer.uint32(29).float(message.position);
        }
        if (message.volume !== undefined) {
            writer.uint32(37).float(message.volume);
        }
        if (message.playbackRate !== undefined) {
            writer.uint32(45).float(message.playbackRate);
        }
        if (message.loop !== undefined) {
            writer.uint32(48).bool(message.loop);
        }
        return writer;
    }
    PBVideoPlayer.encode = encode;
    function decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePBVideoPlayer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.src = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.playing = reader.bool();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.position = reader.float();
                    continue;
                case 4:
                    if (tag !== 37) {
                        break;
                    }
                    message.volume = reader.float();
                    continue;
                case 5:
                    if (tag !== 45) {
                        break;
                    }
                    message.playbackRate = reader.float();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.loop = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    }
    PBVideoPlayer.decode = decode;
})(PBVideoPlayer || (PBVideoPlayer = {}));
